import { ValidatorFn, Validators } from '@angular/forms';

export function CustomPatternValidator(pattern: string | RegExp, message: string): ValidatorFn {
    const base = Validators.pattern(pattern);
    return (control) => {
        const res = base(control);
        const p = (res as any)?.pattern;
        if (!p) return res;
        return { customPatternError: message ?? 'Invalid pattern' };
    };
}
